export default "/assets/images/attic-video.mp4?febf7ebbdd5617c841964ef4718dfc18";